import React from 'react';
import PropTypes from 'prop-types';
import './analytics-icon.scss';

function IncrementIcon({ onClick }) {
    return (
        <span onClick={onClick} className='analytics-icon'>
            <svg
                focusable='false'
                viewBox='0 0 24 24'
                aria-hidden='true'
                tabIndex='-1'
                title='Sync'>
                <path fill="white" d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'>
                </path>
            </svg>
        </span>
    );
}


IncrementIcon.propTypes = {
    onClick: PropTypes.func
};

export default IncrementIcon;
